import React, { useLayoutEffect, useState } from 'react';

interface IDomainNameContext {
  domainName: string;
}

function useDomainName(): string {
  const [domainName, setDomainName] = useState('');
  useLayoutEffect(() => {
    setDomainName(window.location.hostname);
  }, []);
  return domainName;
}

const DomainNameContext = React.createContext<IDomainNameContext>({
  domainName: 'software.ercexpert.com',
});

export { DomainNameContext, useDomainName };
